module.exports = __webpack_public_path__ + "img/pagoefectivo.13d3c936.png";